<div class="spinner-overlay">
    <img src="assets/loading_v2_w-looped.gif" alt="loading-spinner" />
</div>
